import React, { useState, useEffect } from "react";
// import logo from '../img/logo.png';

const NavigationBar = () => {
  const [email, setEmail] = useState("");
  const [signup, setSignup] = useState("");
  const [businessData, setBusinessData] = useState(null);
  const [tooltipText, setTooltipText] = useState("");
  useEffect(() => {
    // Retrieve email address from localStorage
    const email_address = window.localStorage.getItem("email_address");
    const signup = window.localStorage.getItem("signup");
    const business_id = window.localStorage.getItem("business_id");

    // Update the state with the retrieved email address
    setEmail(email_address);
    setSignup(signup);
    if (signup === "user" && business_id) {
      fetchBusinessData(business_id);
    }
  }, [email, signup]);
  const fetchBusinessData = async (businessId) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_APIURL}business/store/info?business_id=${businessId}`);
      const data = await response.json();
      if (data.status === "success") {
        setBusinessData(data.result);
      } else {
        setBusinessData({ has_web_store: false, store_status: null });
      }
    } catch (error) {
      console.error("Error fetching business data:", error);
      setBusinessData({ has_web_store: false, store_status: null });
    }
  };

  const createWebStore = async () => {
    const business_id = window.localStorage.getItem("business_id");

    if (!business_id) {
      alert("Business ID not found. Please login again.");
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_APIURL}business/store/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ business_id })
      });

      const data = await response.json();

      if (data.status === "success") {
        alert("Web store created successfully!");
        // Refresh business data to show the new store
        fetchBusinessData(business_id);
      } else {
        alert(data.error?.message || "Failed to create web store");
      }
    } catch (error) {
      console.error("Error creating web store:", error);
      alert("An error occurred while creating the web store");
    }
  };
  function logout() {
    const confirmLogout = window.confirm("Are you sure you want to exit?");
    if (confirmLogout) {
        localStorage.clear();
        window.location.href = "/login"; // Redirect to login page
    }
    // If user clicks "Cancel", nothing happens and stays on the same page
}

  const handleProfile = (data) => {
    let displayName;

    if (data.length > 20) {
      const prefix = data.substring(0, 4); // Get the first 4 characters
      const domain = data.substring(data.indexOf("@")); // Get the domain part starting from '@'
      displayName = prefix + "....." + domain;
    } else {
      displayName = data;
    }
    return displayName;
  };
  const handleMouseOver = () => {
    setTooltipText(email);
  };

  const handleMouseOut = () => {
    setTooltipText("");
  };
  const path = window.location.pathname;
  return (
    <div>
      {/* Navbar */}
      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        {/* Left navbar links */}
        <ul className="navbar-nav">
          <li className="nav-item">
            <a
              className="nav-link"
              data-widget="pushmenu"
              href="#"
              role="button"
            >
              <i className="fas fa-bars" />
            </a>
          </li>
        </ul>
        {/* Right navbar links */}
        <ul className="navbar-nav ml-auto">
          <li className="nav-item dropdown">
            <a className="nav-link  p-1" data-toggle="dropdown" href="#">
              <div className="user-panel d-flex">
                <div className="image user_div">
                  {/* <img src="dist/img/user.png" class="img-circle elevation-2" alt="User Image"> */}
                  <span className="usercharacter">
                    {email ? email.charAt(0).toUpperCase() : ""}
                  </span>
                </div>
                <div className="info">
                  <span
                    className="d-block f_black"
                    onMouseOver={handleMouseOver}
                    onMouseOut={handleMouseOut}
                    title={email}
                  >
                    {handleProfile(email)}{" "}
                    <i className="fa-solid fa-angle-down" />
                  </span>
                </div>
              </div>
            </a>
            <div className="dropdown-menu dropdown-menu-right">
              <a href="#" className="dropdown-item" onClick={logout}>
                <i className="fa-solid fa-arrow-right-from-bracket mr-2" />{" "}
                Logout
              </a>
            </div>
          </li>
        </ul>
      </nav>
      {/* /.navbar */}
      {/* Main Sidebar Container */}
      <aside className="main-sidebar sidebar-dark-primary elevation-4">
        {/* Brand Logo */}
        <a href="#" className="brand-link logo-switch">
          <img
            src="assets/img/logo_sm.png"
            alt="PPEX"
            className="brand-image-xl logo-xs"
          />
          <img
            src="assets/img/logo.png"
            alt="PPEX"
            className="brand-image-xs logo-xl"
            style={{ left: 60 }}
          />
        </a>
        {/* Sidebar */}
        <div className="sidebar">
          {/* Sidebar Menu */}
          <nav className="mt-2">
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              {/* Add icons to the links using the .nav-icon class
         with font-awesome or any other icon font library */}

              {/* <li className="nav-item">
                <a
                  href="/list"
                  className={`nav-link ${path === "/list" || path === "/products" ? "active" : ""
                    }`}
                >
                  <i className="nav-icon fa-solid fa-box-open" />
                  <p>Products</p>
                </a>
              </li> */}
              {signup === "admin" ? <li className="nav-item">
                <a
                  href="/businesses"
                  className={`nav-link ${path.startsWith("/businesses") ? "active" : ""
                    }`}
                >
                  <i className="nav-icon fa-solid fas fa-briefcase" />
                  <p>Businesses</p>
                </a>
              </li> : ""}
              {signup === "admin" ? <li className="nav-item">
                <a
                  href="/users"
                  className={`nav-link ${path.startsWith("/user") ? "active" : ""
                    }`}
                >
                  <i className="nav-icon fa-solid fa-users" />
                  <p>Users</p>
                </a>
              </li> : ""}

              <li className="nav-item">
                <a
                  href="/gift"
                  className={`nav-link ${path.startsWith("/gift") ? "active" : ""
                    }`}
                >
                  <i className="nav-icon fa-solid fa-gift" />
                  <p>Product</p>
                </a>
              </li>
              {/* <li className="nav-item">
                <a
                  href="/greetingcard"
                  className={`nav-link ${path.startsWith("/greeting") ? "active" : ""
                    }`}
                >
                  <i className="nav-icon fa-solid fa-id-card-clip" />
                  <p>Greeting Card</p>
                </a>
              </li> */}
              <li className="nav-item">
                <a
                  href="/category"
                  className={`nav-link ${path.startsWith("/category") ? "active" : ""
                    }`}
                >
                  <i className="nav-icon fa-solid fa-tags" />
                  <p>Category</p>

                </a>
              </li>
              <li className="nav-item">
                <a
                  href="/ordermanagement"
                  className={`nav-link ${path.startsWith("/ordermanagement") ? "active" : ""
                    }`}
                >
                  <i className="nav-icon fa-solid fa-box" />
                  <p>Order Management</p>
                </a>
              </li>
              {signup === "user" && businessData && businessData.store_status == 'active' && (
                <>
                  <li className="nav-header">WEB STORE</li>
                  <li className="nav-item">
                    <a href="/webstore_settings" className={`nav-link ${path.startsWith("/webstore/settings") ? "active" : ""}`}>
                      <i className="nav-icon fa-solid fa-cog" />
                      <p>Store Settings</p>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      href={`https://${businessData.store_subdomain}.eventseasy.in`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="nav-link"
                    >
                      <i className="nav-icon fa-solid fa-external-link-alt" />
                      <p>
                        View Store
                        <span className={`badge badge-sm right ${businessData.store_status === 'active' ? 'badge-success' :
                          businessData.store_status === 'inactive' ? 'badge-warning' : 'badge-danger'
                          }`}>
                          {businessData.store_status}
                        </span>
                      </p>
                    </a>
                  </li>
                </>
              )}

              {signup === "user" && businessData && (!businessData.has_web_store || businessData.store_status !== 'active') && (
                <>
                  <li className="nav-header">WEB STORE</li>
                  <li className="nav-item">
                    <a
                      href="#"
                      className={`nav-link ${path.startsWith("/webstore/create") ? "active" : ""}`}
                      onClick={(e) => {
                        e.preventDefault();
                        createWebStore();
                      }}
                    >
                      <i className="nav-icon fa-solid fa-plus-circle" />
                      <p>Create Web Store</p>
                    </a>
                  </li>
                </>
              )}
            </ul>
          </nav>
          {/* /.sidebar-menu */}
        </div>
        {/* /.sidebar */}
      </aside>
    </div>
  );
};

export default NavigationBar;
